import { stipAxios } from '../axios';

const BASE_ENDPOINT = '/documento-sistema';

const manualEndpoints = {
    getAll: () => stipAxios.get(`/guest${BASE_ENDPOINT}/find-all`),
    save: (payload) => stipAxios.post(`${BASE_ENDPOINT}/save/`, payload),
};

export default manualEndpoints;
